export const SYLLABUS_SLUG_PARAM = 'syllabusSlug';
